/* eslint-disable camelcase */
import * as React from 'react';

type Locale = 'en' | 'es';

type Phrase = (
  locale: Locale,
  params: {
    transformFn: React.FC<{ text: string }>;
  },
) => React.ReactNode;

export const i18n_bonus_free_digital_practice_journal: Phrase = (locale, { transformFn }) => {
  const en = <>{transformFn({ text: `Bonus:` })} Free digital practice journal</>;
  const phrases: { [key: string]: undefined | React.ReactNode } = {
    en,
    es: <>Diario de yoga digital gratuito</>,
  };
  return phrases[locale] || en;
};
